import { AnimatePresence, motion } from 'motion/react';

import styles from './Title.module.css';

export const Title = ({ isWinnerStage }) => {
  const currentTitle = isWinnerStage ? 'ПОБЕДИТЕЛЬ' : 'РОЗЫГРЫШ ПРИЗОВ!';

  return (
    <div className={styles.titleBlock}>
      <AnimatePresence mode="wait">
        <motion.div
          className={styles.title}
          key={currentTitle + isWinnerStage}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.7 }}
        >
          {currentTitle}
        </motion.div>
      </AnimatePresence>

      <AnimatePresence mode="wait">
        <motion.div
          key={`${currentTitle + isWinnerStage}-back`}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.7 }}
          className={styles.titleMask}
        />
      </AnimatePresence>
    </div>
  );
};
